export type ProductSelectOption = {
  id: string
  name: string
}

export type ProductMultiSelectProps = {
  products: ProductSelectOption[]
  selectedIds: string[]
  disabled?: boolean
  onChange: (ids: string[]) => void
}

export const PRODUCT_SELECT = {
  label: 'Products',
  searchPlaceholder: 'Search products…',
  selectAll: 'Select all',
  clear: 'Clear',
  empty: 'No products left to assign.',
  noMatches: 'No products match this search.',
  selectedCount: (count: number) =>
    count === 1 ? '1 selected' : `${count} selected`,
  remove: 'Remove',
} as const
